import { FormTemplate } from 'data/template/template.types';

export const filterGroupTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Filter Group',
  key: 'filterGroup',
  main: {
    metadata: {
      layout: {
        rows: [
          ['fgId', 'name', '$empty'],
        ],
      },
    },
    fields: {
      fgId: {
        label: 'Filter Group ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 64,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      name: {
        label: 'Filter Group Name',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 256,
            },
          ],
        },
      },
    },
  },
};
